import React from 'react'
import FilterRadioBtn from './FilterRadioBtn'
import FilterSelect from './FilterSelect'

const PeriodFilterBlock = (props) => {
  const { radio, select } = props

  return (
    <>
      <FilterRadioBtn {...radio} />
      {select && radio.isChecked && <FilterSelect {...select} />}
    </>
  )
}

export default PeriodFilterBlock
